// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"b1aa84d4","66":"3978840b","226":"ed50a735","277":"b33662bf","313":"3ff71003","453":"83a6c87f","607":"ed50a735","827":"cee4d9dc","839":"2224ad38","845":"ed50a735","988":"ed50a735"}[chunkId] + ".chunk.js";
};